import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ce41d97e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row mb-4 gx-5" }
const _hoisted_2 = { class: "col-12 col-md-6" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "lat",
  class: "col-form-label text-gray-700 fw-bold required"
}, "Latitud", -1))
const _hoisted_4 = {
  key: 0,
  class: "form-control form-control-solid"
}
const _hoisted_5 = { for: "" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  key: 0,
  class: "mt-1 mb-0"
}
const _hoisted_8 = { class: "col-12 col-md-6" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "lng",
  class: "col-form-label text-gray-700 fw-bold required"
}, "Longitud", -1))
const _hoisted_10 = {
  key: 0,
  class: "form-control form-control-solid"
}
const _hoisted_11 = { for: "" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 0,
  class: "mt-1 mb-0"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        (_ctx.isReadOnly)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_ctx.isReadOnly)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.value[_ctx.latKey]), 1)
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _withDirectives(_createElementVNode("input", {
                id: "lat",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value[_ctx.latKey]) = $event)),
                type: "number",
                placeholder: "Ej. 14.0818",
                class: "form-control form-control-solid",
                disabled: _ctx.isReadOnly,
                onKeyup: _cache[1] || (_cache[1] = ($event: any) => (_ctx.validationState.lat?.$touch()))
              }, null, 40, _hoisted_6), [
                [_vModelText, _ctx.value[_ctx.latKey]]
              ]),
              (_ctx.validationState.lat?.$errors?.length)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_7, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validationState.lat.$errors, (error) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: error.$uid,
                        class: "text-danger fw-bold mb-0"
                      }, _toDisplayString(error.$message), 1))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ], 64))
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        (_ctx.isReadOnly)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_ctx.isReadOnly)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.value[_ctx.lngKey]), 1)
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _withDirectives(_createElementVNode("input", {
                id: "lng",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.value[_ctx.lngKey]) = $event)),
                type: "number",
                placeholder: "Ej. -87.2068",
                class: "form-control form-control-solid",
                disabled: _ctx.isReadOnly,
                onKeyup: _cache[3] || (_cache[3] = ($event: any) => (_ctx.validationState.lng?.$touch()))
              }, null, 40, _hoisted_12), [
                [_vModelText, _ctx.value[_ctx.lngKey]]
              ]),
              (_ctx.validationState.lng?.$errors?.length)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_13, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validationState.lng.$errors, (error) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: error.$uid,
                        class: "text-danger fw-bold mb-0"
                      }, _toDisplayString(error.$message), 1))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ], 64))
      ])
    ]),
    _createElementVNode("div", {
      ref: _ctx.ref,
      class: "w-100"
    }, null, 512)
  ]))
}